const accordionData = [
  {
    id: "1",
    title: "01. Discovery & Ideation",
    content:
      "Focus on data-driven decision-making, insights, AI-driven research, and stakeholder alignment to define project goals.",
  },
  {
    id: "2",
    title: "02. Design and Prototyping",
    content:
      "User-centered, agile, rapid prototyping and modular AI-assisted tools for agile iteration, productivity, and efficiency.",
  },
  {
    id: "3",
    title: "03. Agile Development & CI",
    content:
      "Cloud-native architecture, microservices, and CI/CD pipelines for scalable and efficient development.",
  },
  {
    id: "4",
    title: "04. Optimization",
    content:
      "Predictive, self-healing, and automated systems for stability and scalability. Performance tuning, code optimization, and system readiness to ensure smooth deployment.",
  },
  {
    id: "5",
    title: "05. Testing & QA (AI-Enabled)",
    content:
      "AI-powered, automated testing with security and performance testing embedded from the start. Automated AI-powered testing with a focus on performance, security, and quality assurance.",
  },
  {
    id: "6",
    title: "06. Deployment",
    content:
      "Cloud-native, multi-cloud deployments with Infrastructure as Code (IaC) and automated pipelines.",
  },

  {
    id: "7",
    title: "07. Support & Maintenance",
    content:
      "Continuous improvement through data, AI, and performance optimization tools. AI-driven performance monitoring, self-healing systems, continuous stability enhancements, and proactive customer support.",
  },
];

export default accordionData;
